export default __webpack_public_path__ + "static/media/p17.3c7adef0.jpg";